(function () {
	angular
		.module('trackeye')
		.factory('OpenLayersService', OpenLayersService);

	OpenLayersService.$inject = ['OpenLayers', 'OLFeature', 'OLCoord', '$rootScope'];

	function OpenLayersService(OpenLayers, OLFeature, OLCoord, $rootScope) {
		var instance = undefined,
			current_coord = undefined,
			initial_zoom = 16,
			exports = {};

		/**
		 * @param elem
		 * @returns void
		 */
		exports.initialize = function (elem) {
			instance = new OpenLayers(elem);

			setTimeout(function () {
				$rootScope.$broadcast('OpenLayersService.ready', instance);
			}, 200)
		};

		exports.getInitialZoom = function () {
			return initial_zoom;
		};

		exports.getCurrentCoord = function () {
			return current_coord;
		};

		exports.hasCoord = function () {
			return !!current_coord;
		};

		exports.setCurrentCoord = function (coord) {
			current_coord = coord;
		};

		/**
		 * Move features to a given lon/lat
		 * @param {string[]} names - Name of feature
		 * @param {SutMessage} message
		 * @param {boolean} [center]
		 */
		exports.moveFeatures = function (names, message, center) {
			exports.setCurrentCoord(new OLCoord(message.getCoord()));

			instance.moveFeatures(names, message);

			if (center)
				instance.setCenter(message);

			return exports;
		};

		/**
		 * Show given features on the map
		 * @param {string[]} names - Name of a feature
		 */
		exports.showFeatures = function (names) {
			instance.showFeatures(names);
			return exports;
		};

		exports.hideCircles = function() {
			instance.hideAllCircles();
			return exports;
		};

		/**
		 * Show all features on the map
		 */
		exports.showAllFeatures = function () {
			instance.showAllFeatures();
			return exports;
		};

		exports.setInitialZoom = function () {
			exports.setZoom(initial_zoom);
		};

		exports.setZoom = function (zoom) {
			instance.setZoom(zoom);
			return exports;
		};

		exports.setFocus = function (layer) {
			if (!layer)
				layer = 'circleLayer';

			instance.setFocus(layer);
			return exports;
		};
		/**
		 * Hide given features from the map
		 * @param {string[]} names - Name of a feature
		 */
		exports.hideFeatures = function (names) {
			instance.hideFeatures(names);
			return exports;
		};

		/**
		 * Hide all features from the map
		 */
		exports.hideAllFeatures = function (zoom) {
			instance.clearAllVectors();

			if (zoom)
				instance.setZoom(zoom);

			return exports;
		};

		/**
		 * Set center of the map
		 * @param {SutMessage} message
		 */
		exports.setCenter = function (message) {
			instance.setCenter(message);
			return exports;
		};

		/**
		 * Trigger a re-render of the map, if the viewport has changed
		 */
		exports.updateSize = function () {
			instance.updateSize();
			return exports;
		};

		/**
		 * @returns {OpenLayers}
		 */
		exports.getInstance = function () {
			return instance;
		};

		/**
		 * Create a circle feature
		 * @param {Device} device
		 * @param {SutMessage} [message]
		 * @returns {OLFeature}
		 */
		exports.createCircle = function (device, message) {
			if (!message)
				message = device.latest;

			return new_feature(device, 'circle', message);
		};

		/**
		 * Create an icon feature
		 * @param {Device} device
		 * @param {SutMessage} [message]
		 * @returns {OLFeature}
		 */
		exports.createIcon = function (device, message) {
			if (!message)
				message = device.latest;

			return new_feature(device, 'marker', message, device.getFleet());
		};

		exports.on = function(name, cb) {
			instance.setListener(name, cb);
		};

		/**
		 *
		 * @param {Device} device
		 * @param {string} type
		 * @param {SutMessage} [message]
		 * @param {string} [marker_name]
		 * @return {OLFeature}
		 */
		function new_feature(device, type, message, marker_name) {
			var feature = new OLFeature(device, message);

			feature.is(type, marker_name);
			instance.addFeatures([feature]);

			return feature;
		}

		return exports;
	}
})();